import axios from 'axios'

// Interfaces
import { CgiCollectRequest, CgiCollectResult, IsMrmResponse, CgiActivateResult, SubmissionResponse } from '../interfaces/API'
import { CgiProvider } from '../interfaces/CGI';

// Utils
import { setAntiForgeryTokenToAxiosRequest } from '../utilities/utils';

const client = axios.create({
    baseURL: window.location.origin,
    headers: {
        'Content-Type': 'application/json'
    }
});

client.interceptors.request.use(setAntiForgeryTokenToAxiosRequest);

export const activateCGI = (provider: CgiProvider) => {
    const url = '/umbraco/surface/MemberApplicationSurface/ActivateCgi';
    return client.post<CgiActivateResult>(url, JSON.stringify(provider))
}

export const loginWithoutCGI = (personalIdentityNumber: string) => {
    const url = '/umbraco/surface/MemberApplicationSurface/LoginWithoutCGI';
    return client.post<CgiCollectResult>(url, JSON.stringify(personalIdentityNumber))
}

export const checkForCGISignature = (request: CgiCollectRequest) => {
    const url = '/umbraco/surface/MemberApplicationSurface/CollectCgiResponse'
    return client.post<CgiCollectResult>(url, request);
}

export const isMrmProduction = () => {
    var url = '/umbraco/surface/UtilitySurface/IsMrmProduction';
    return client.get<IsMrmResponse>(url);
}

export const sendApplication = (dataToSend: any) => {
    var url = '/umbraco/surface/MemberApplicationSurface/Apply';
    return client.post<SubmissionResponse>(url, dataToSend);
}

export const sendApplicationNoEId = (dataToSend: any) => {
    var url = '/umbraco/surface/MemberApplicationSurface/ApplyWithoutEId';
    return client.post<SubmissionResponse>(url, dataToSend);
}